import { type VFC } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { AttributesListWidget } from "../core/navigation-panel/AttributeWidget.js";
import GenericVariantsView from "./GenericVariantsView.js";
import { renderProteinAttributesWidgets } from "@/app-utils/attributes-widgets.tsx";
import { useURLViewID } from "@/app-utils/hooks/useUrl.ts";
import { type InputTableQuerySpec } from "@/graphql.ts";
import { type IProteinState } from "@/redux/modules/protein.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { DATATABLE_ID_TYPE, ENTITY_TYPE } from "@/settings/settings.js";

const ProteinVariantsView: VFC = () => {
  const { proteinId } = useParams<"proteinId">();
  const { protein, isLoading } = useSelector<IAppState, IProteinState>((state) => state.protein);
  const viewId = useURLViewID();
  const refGenomeId = useSelector<IAppState>((state) => state.auth.session?.params?.referenceGenome);

  const tableSpec: InputTableQuerySpec = !isLoading &&
    refGenomeId && {
      id: proteinId,
      idType: DATATABLE_ID_TYPE.ENTITY,
      queryType: ENTITY_TYPE.PROTEIN,
      resultType: ENTITY_TYPE.PROTEIN_MUTATION,
      restrictions: { refGenomeId },
    };

  return (
    <GenericVariantsView
      title={protein?.systematicName}
      subtitle={protein?.description || "List of Variants"}
      headerAttributes={[
        <AttributesListWidget
          attributes={renderProteinAttributesWidgets(protein)}
          key={"protein-variants-view-widget-1"}
        />,
      ]}
      tableSpec={tableSpec}
      viewId={viewId ?? undefined}
      getSummaryEntityName={() => protein?.systematicName}
    />
  );
};

export default ProteinVariantsView;
